/* tslint:disable: member-ordering*/
import { Observable, of as observableOf } from 'rxjs';

import {
    share,
    catchError,
    map,
    switchMap,
} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AdvisorAction } from './advisor.action';
import { AppState } from '../../interfaces/app-state.interface';
import { AdvisorService } from '../../services/advisor/advisor.service';

@Injectable()
export class AdvisorEffects {
    constructor(
        private actions$: Actions<AdvisorAction>,
        private store: Store<AppState>,
        private advisorService: AdvisorService
    ) { }

    /** Verifica se o usuário possui assessor exclusivo */
    @Effect()
    public getAdvisor$ = this.actions$.pipe(
        ofType(AdvisorAction.getAdvisor),
        switchMap(
            () => this.advisorService
                .getAdvisor()
                .map((payload) => {
                    return {
                        payload,
                        type: AdvisorAction.getAdvisorSuccess,
                    }
                })
                .catch(({ message }) => {
                    return Observable.of({
                        type: AdvisorAction.getAdvisorError,
                        payload: message,
                    })
                }),
        ),
        share()
    );
}
